module.exports = __webpack_public_path__ + "img/SocialFi.ad788c60.png";